import { theme } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";

import { useAppBarStickyHeightValue } from "~/components/app-bar/hooks";
import type { DefaultComponentsProvider } from "~/components/article/article-render";
import { Right } from "~/components/article/article-render/article-content/article-content-right-section/styles";
import {
  DesktopRightSectionAdSlot,
  RightSection,
  RightSectionSticky,
} from "~/components/article/article-render/generic-article/styles";

type Props = {
  className?: string;
  provider: DefaultComponentsProvider;
  shouldRender: boolean;
  shouldRenderRemaining: boolean;
  shouldRenderSecondAd: boolean;
};

export const ArticleContentRightSection: FunctionComponent<Props> = ({
  className,
  provider,
  shouldRender,
  shouldRenderRemaining,
  shouldRenderSecondAd,
}) => {
  const { appBarStickyHeight } = useAppBarStickyHeightValue();

  return shouldRender ? (
    <Right className={className}>
      <RightSection>
        <RightSectionSticky $stickyStackedHeight={appBarStickyHeight}>
          <DesktopRightSectionAdSlot>
            {provider.adslot({
              adUnit: "d_lrec1",
              breakpoint: theme.breakpoints.up("desktop"),
              sizes: [[300, 250], [300, 600], "fluid"],
            })}
          </DesktopRightSectionAdSlot>
          {shouldRenderSecondAd && (
            <DesktopRightSectionAdSlot>
              {provider.adslot({
                adUnit: "native4",
                autoRefreshOptions: {
                  disableIntervalRefresh: true,
                  disableScrollBackRefresh: true,
                },
                breakpoint: theme.breakpoints.up("desktop"),
                fluidDefaultSize: {
                  height: 260,
                },
                sizes: ["fluid"],
              })}
            </DesktopRightSectionAdSlot>
          )}
        </RightSectionSticky>
      </RightSection>
      {shouldRenderRemaining && (
        <>
          {provider.moreOnThis({ variant: "vertical" })}
          <RightSection>
            <RightSectionSticky $stickyStackedHeight={appBarStickyHeight}>
              <DesktopRightSectionAdSlot>
                {provider.adslot({
                  adUnit: "d_lrec2",
                  breakpoint: theme.breakpoints.up("desktop"),
                  sizes: [[300, 250], [300, 600], [320, 480], "fluid"],
                })}
              </DesktopRightSectionAdSlot>
            </RightSectionSticky>
          </RightSection>
          <RightSection>
            <RightSectionSticky $stickyStackedHeight={appBarStickyHeight}>
              <DesktopRightSectionAdSlot>
                {provider.adslot({
                  adUnit: "d_lrec3b",
                  breakpoint: theme.breakpoints.up("desktop"),
                  sizes: [[300, 250], [300, 600], [320, 480], "fluid"],
                })}
              </DesktopRightSectionAdSlot>
            </RightSectionSticky>
          </RightSection>
        </>
      )}
    </Right>
  ) : null;
};
